import { module } from 'angular';
import ngInfiniteScroll from 'ng-infinite-scroll';
import { ngModule as foundationPricingModule } from 'cg-foundation-pricing';
import { ngModule as foundationThemingModule } from 'cg-foundation-theming';
import { BrandSelectComponent } from './components/brand-select';
import { DeviceSearchComponent } from './components/device-search';
import { DeviceSearchTabComponent } from './components/device-search-tab';
import { DeviceSearchTabsComponent } from './components/device-search-tabs';
import { FiltersComponent } from './components/filters';
import { LastViewedDevicesComponent } from './components/last-viewed-devices';
import { SearchResultsCountComponent } from './components/search-results-count.component';
import { SearchSorterComponent } from './components/search-sorter';
import { SolutionBundleComponent } from './components/solution-bundle';
import { SolutionBundleProtocolComponent } from './components/solution-bundle-protocol';
import { SolutionFamilyComponent } from './components/solution-family';
import { SolutionGroupComponent } from './components/solution-group';
import { SolutionGroupCardComponent } from './components/solution-group-card';
import { SolutionOtherProductsComponent } from './components/solution-other-products';
import { SolutionThirdPartyProductComponent } from './components/solution-third-party-product';
import { SolutionThirdPartyProductWtuComponent } from './components/solution-third-party-product-wtu';
import { SolutionsComponent } from './components/solutions';
import { ThirdPartyDevicesComponent } from './components/third-party-devices';
import { ViewChageComponent } from './components/view-change';
import { AccessoryGroupRelationDirective } from './directives/accessory-group-relation';
import { AttributeIconsDirective } from './directives/attribute-icons';
import { ClearSelectionDirective } from './directives/clear-selection';
import { DeviceTypeIconDirective } from './directives/device-type-icon';
import { DotDotDotDirective } from './directives/dot-dot-dot';
import { FeaturedProtocolsDirective } from './directives/featured-protocols';
import { ResolutionBreakpointsDirective } from './directives/resolution-breakpoints';
import { ScrollToItemDirective } from './directives/scroll-to-item';
import { AttributeIconService } from './services/attribute-icon-service';
import { DeviceTypeSearchService } from './services/device-type-search';
import { LastViewedService } from './services/last-viewed-service';
import { ProtocolConfigurationService } from './services/protocol-configuration-service';
import { QueryBuilderService } from './services/query-builder-service';
import { SearchConfigurationService } from './services/search-configuration-service';
import { SearchStateService } from './services/search-state-service';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.search', [
    'angularLazyImg',
    'angular-carousel',
    ngInfiniteScroll,
    foundationThemingModule.name,
    foundationPricingModule.name,
])
    .service('attributeIconService', AttributeIconService)
    .service('lastViewedService', LastViewedService)
    .service('deviceTypeSearch', DeviceTypeSearchService)
    .service('protocolConfiguration', ProtocolConfigurationService)
    .service('queryBuilder', QueryBuilderService)
    .service('searchConfiguration', SearchConfigurationService)
    .service('searchStateService', SearchStateService)
    .component('brandSelect', BrandSelectComponent)
    .component('deviceSearchTab', DeviceSearchTabComponent)
    .component('deviceSearchTabs', DeviceSearchTabsComponent)
    .component('deviceSearch', DeviceSearchComponent)
    .component('filters', FiltersComponent)
    .component('lastViewedDevices', LastViewedDevicesComponent)
    .component('searchSorter', SearchSorterComponent)
    .component('searchResultsCount', SearchResultsCountComponent)
    .component('solutionBundle', SolutionBundleComponent)
    .component('solutionBundleProtocol', SolutionBundleProtocolComponent)
    .component('solutionFamily', SolutionFamilyComponent)
    .component('solutionGroup', SolutionGroupComponent)
    .component('solutionGroupCard', SolutionGroupCardComponent)
    .component('solutionOtherProducts', SolutionOtherProductsComponent)
    .component('solutionThirdPartyProduct', SolutionThirdPartyProductComponent)
    .component('solutionThirdPartyProductWtu', SolutionThirdPartyProductWtuComponent)
    .component('solutions', SolutionsComponent)
    .component('thirdPartyDevices', ThirdPartyDevicesComponent)
    .component('viewChange', ViewChageComponent)
    .directive('accessoryGroupRelation', AccessoryGroupRelationDirective)
    .directive('attributeIcons', AttributeIconsDirective)
    .directive('clearSelection', ClearSelectionDirective)
    .directive('deviceTypeIcon', DeviceTypeIconDirective)
    .directive('dotdotdot', DotDotDotDirective)
    .directive('featuredProtocols', FeaturedProtocolsDirective)
    .directive('resolutionBreakpoints', ResolutionBreakpointsDirective)
    .directive('scrollToItem', ScrollToItemDirective);
